import axios from "../utils/axios";

/**
 * Get all airports with filters and pagination
 */
export const getAirports = async (page = 1, perPage = 15, filters = {}) => {
    const params = {
        page,
        per_page: perPage,
        ...filters,
    };
    const response = await axios.get("/airports", { params });
    return response.data;
};

/**
 * Get a single airport by ID
 */
export const getAirportById = async (id) => {
    const response = await axios.get(`/airports/${id}`);
    return response.data;
};

/**
 * Get airports for select dropdowns
 * @param {number|string} cityId - Optional city ID to filter airports
 */
export const getAirportsForSelect = async (cityId = null) => {
    const params = cityId ? { city_id: cityId } : {};
    const response = await axios.get("/airports/flight-for-select", { params });
    return response.data;
};

/**
 * Create a new airport
 */
export const createAirport = async (data) => {
    const response = await axios.post("/airports", data);
    return response.data;
};

/**
 * Update an existing airport
 */
export const updateAirport = async (id, data) => {
    const response = await axios.put(`/airports/${id}`, data);
    return response.data;
};

/**
 * Delete an airport (Soft delete)
 */
export const deleteAirport = async (id) => {
    const response = await axios.delete(`/airports/${id}`);
    return response.data;
};

/**
 * Mass delete airports (Soft delete)
 */
export const massDeleteAirports = async (ids) => {
    const response = await axios.delete("/airports/mass-destroy", {
        data: { items: ids },
    });
    return response.data;
};

/**
 * Force delete an airport
 */
export const forceDeleteAirport = async (id) => {
    const response = await axios.delete(`/airports/${id}/force-delete`);
    return response.data;
};

/**
 * Mass force delete airports
 */
export const massForceDeleteAirports = async (ids) => {
    const response = await axios.delete("/airports/mass-force-delete", {
        data: { items: ids },
    });
    return response.data;
};

/**
 * Restore a soft-deleted airport
 */
export const restoreAirport = async (id) => {
    const response = await axios.post(`/airports/${id}/restore`);
    return response.data;
};

/**
 * Mass restore soft-deleted airports
 */
export const massRestoreAirports = async (ids) => {
    const response = await axios.post("/airports/mass-restore", {
        items: ids,
    });
    return response.data;
};
